var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.4842 18.8436C21.2811 19.7811 21.1404 21.1873 20.1561 21.9842C19.7342 22.3123 19.2654 22.4998 18.7498 22.4998C18.0936 22.4998 17.4373 22.2186 17.0154 21.6561L11.9998 15.5623L6.98419 21.6561C6.56232 22.2186 5.90607 22.4998 5.24982 22.4998C4.73419 22.4998 4.26544 22.3123 3.84357 21.9842C2.85919 21.1873 2.71857 19.7811 3.51544 18.8436L9.09357 11.9998L3.51544 5.15607C2.71857 4.21857 2.85919 2.81232 3.84357 2.01544C4.78107 1.21857 6.18732 1.35919 6.98419 2.34357L11.9998 8.43732L17.0154 2.34357C17.8123 1.35919 19.2186 1.21857 20.1561 2.01544C21.0936 2.81232 21.2811 4.21857 20.4842 5.15607L14.9061 11.9998L20.4842 18.8436Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fac6e10cf32cb0391ad4cd9d2048e5e9.svg";
export { ForwardRef as ReactComponent };